import { render, staticRenderFns } from "./add.html?vue&type=template&id=0f51b595&scoped=true&"
import script from "./add.js?vue&type=script&lang=js&"
export * from "./add.js?vue&type=script&lang=js&"
import style0 from "./add.scss?vue&type=style&index=0&id=0f51b595&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f51b595",
  null
  
)

export default component.exports